import { Box, CircularProgress } from '@mui/material';

import { useSxStyles } from './useStyles';

type OwnProps = {
  size?: 'small' | 'normal';
};

type Props = OwnProps;

export const LegacyLoading = (props: Props) => {
  const sxStyles = useSxStyles();
  const { size = 'normal' } = props;

  return (
    <Box sx={sxStyles.root}>
      <CircularProgress
        sx={sxStyles.progress}
        size={size === 'normal' ? 50 : 40}
      />
    </Box>
  );
};
